// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import UploadedFileEditScreen from "../../../src/screens/uploaded-files/edit-screen"
import ScreenTitle from "../../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} UploadedFileEditRouteProps */

/** @typedef {Record<string, never>} UploadedFileEditRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<UploadedFileEditRouteProps, UploadedFileEditRouteState>}
 */
class UploadedFileEditRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("Edit file")}</ScreenTitle>
        <UploadedFileEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<UploadedFileEditRouteProps>} */
const UploadedFileEditRouteComponent = memo(shapeComponent(UploadedFileEditRoute))

export default UploadedFileEditRouteComponent
